import { z } from 'zod';

import { jobArchitectureGenerationInfoSchema, jobArchitectureItemSchema } from './job-architecture';

export const jobClusterWithTypeSchemaTransformed = jobArchitectureItemSchema
    .extend({
        actions: z.object({ canEdit: z.boolean(), canReadDebugInfo: z.boolean() }).optional().default({
            canEdit: false,
            canReadDebugInfo: false,
        }),
        generationInfo: jobArchitectureGenerationInfoSchema.optional(),
    })
    .transform((jobCluster) => ({
        ...jobCluster,
        type: 'job-cluster' as const,
    }));

export type JobCluster = z.infer<typeof jobClusterWithTypeSchemaTransformed>;
